<template>
  <div>
    <div class="car-form-item car-form-item-vehicles" :class="{'car-form-item-error': !validations.form2.vehicle.required && validations.form2.vehicle.$error}">
      <label for="vehicles">{{$t('hsnTsnIdentification.chooseVehicle')}}*</label>
      <div class="car-select-container" :class="{'car-disabled': !vehicles.length, 'car-filled': form.vehicle }">
        <select id="vehicles"
                v-model="form.vehicle" @change="selectVehicle"
                data-js="hsn-tsn__vehicle--select"
                :disabled="!vehicles.length"
                :class="{'car-disabled': !vehicles.length, 'car-filled': form.vehicle }">
          <option :value="null">{{ $t('hsnTsnIdentification.chooseVehicle') }}*</option>
          <option v-for="(vehicle, index) in vehicles" :key="index"
                  :value="vehicle">{{ vehicle.name }}
          </option>
        </select>
        <div class="car-select-action"></div>
        <spinner v-if="stateObject.vehicle.loading" data-js="hsn-tsn__vehicle--spinner" class="car-spinner car-content-spinner" />
      </div>
      <div class="car-error-message" v-if="!validations.form2.vehicle.required && validations.form2.vehicle.$error">
        {{$t('errors.required')}}
      </div>
      <div class="car-error-message" v-if="stateObject.vehicle.requestError">
        {{$t('hsnTsnIdentification.errors.hsnTsnRequestError')}}
      </div>
    </div>

    <div class="car-form-item car-form-item-month" :class="{'car-form-item-error': !validations.form2.month.required && validations.form2.month.$error}">
      <label for="month">{{$t('hsnTsnIdentification.month')}}*</label>
      <div class="car-select-container" :class="{'car-disabled': !form.vehicle, 'car-filled': form.month }">
        <select name="month" id="month" v-model="form.month"
                :disabled="!form.vehicle"
                data-js="hsn-tsn__month--select"
                :class="{'car-disabled': !form.vehicle, 'car-filled': form.month }">
          <option :value="null">{{ $t('hsnTsnIdentification.month') }}*</option>
          <option v-for="(month) in months" :key="month"
                  :value="getMonthIndex(month)">{{ month }}
          </option>
        </select>
        <div class="car-select-action"></div>
      </div>
      <div class="car-error-message" v-if="!validations.form2.month.required && validations.form2.month.$error">
        {{$t('vinIdentification.errors.month')}}
      </div>
    </div>

    <div class="car-form-item car-form-item-year" :class="{'car-form-item-error': !validations.form2.year.required && validations.form2.year.$error}">
      <label for="year">{{$t('hsnTsnIdentification.year')}}*</label>
      <div class="car-select-container" :class="{'car-disabled': !form.month, 'car-filled': form.year }">
        <select @change="selectYear" id="year" name="year" v-model="form.year"
                :disabled="!form.month"
                data-js="hsn-tsn__year--select"
                :class="{'car-disabled': !form.month, 'car-filled': form.year }">
          <option :value="null">{{ $t('hsnTsnIdentification.year') }}*</option>
          <option v-for="year in years"
                  :key="year" :value="year">{{ year }}
          </option>
        </select>
        <div class="car-select-action"></div>
      </div>
      <div class="car-error-message" v-if="!validations.form2.year.required && validations.form2.year.$error">
        {{$t('vinIdentification.errors.year')}}
      </div>
    </div>

    <div class="car-form-item car-form-item-equipment" :class="{'car-form-item-error': !validations.form2.equipment.required && validations.form2.equipment.$error}">
      <label for="equipment">{{$t('hsnTsnIdentification.chooseEquipments')}}*</label>
      <div class="car-select-container" :class="{'car-disabled': !equipments.length, 'car-filled': form.equipment }">
        <select id="equipment"
                :disabled="!equipments.length"
                data-js="hsn-tsn__equipments--select"
                :class="{'car-disabled': !equipments.length, 'car-filled': form.equipment }"
                v-model="form.equipment"
        >
          <option :value="null">
            {{ $t('hsnTsnIdentification.chooseEquipments') }}*
          </option>
          <option v-for="(equipment, index) in equipments" :key="index" :value="equipment" :data-js="'hsn-tsn__option--' + index">
            <span v-for="(equipmentLine, index) in equipment.values" :key="equipmentLine.id"
                  :value="equipmentLine.dimensionTypeId">
                {{ equipmentLine | optionTranslate }}
              <span v-if="index !== equipment.values.length - 1">| </span>
            </span>
          </option>
        </select>
        <div class="car-select-action"></div>
        <spinner v-if="stateObject.equipment.loading" class="car-spinner car-content-spinner" />
      </div>
      <div class="car-error-message" v-if="!validations.form2.equipment.required && validations.form2.equipment.$error">
        {{$t('errors.required')}}
      </div>
      <div class="car-error-message" v-if="stateObject.equipment.emptyResponse">
        {{$t('hsnTsnIdentification.errors.hsnTsnEmptyResponse')}}
      </div>
      <div class="car-error-message" v-if="stateObject.equipment.requestError">
        {{$t('hsnTsnIdentification.errors.hsnTsnRequestError')}}
      </div>
    </div>
  </div>
</template>

<script>
import Moment from 'moment';
import Spinner from 'vue-simple-spinner';

export default {
  name: 'HsnTsnVehicleForm',
  props: {
    form: {
      type: Object
    },
    validations: {
      type: Object
    },
    vehicles: {
      type: Array
    },
    equipments: {
      type: Array
    },
    stateObject: {
      type: Object
    },
    years: {
      type: Array
    }
  },
  methods: {
    getMonthIndex(monthStr) {
      return Moment().month(monthStr).format('M');
    },
    selectYear() {
      this.$emit('selectYear');
    },
    selectVehicle() {
      this.$emit('selectVehicle');
    }
  },
  computed: {
    months: function () {
      return Moment.months()
    }
  },
  components: {
    Spinner
  }
}
</script>
